/* 
Importing dependencies
*/
import { TheMask } from "vue-the-mask";
import { GetUserDetails } from "../../../config/app.config.js";
import * as service from "./NotificationContactInfo.service";
import * as notificationService from "../../../Service/Notification.service";
import { ReportTypeConstants } from "../../../Constants/ReportTypesConstants";
import { mapGetters } from "vuex";

export default {
  name: "NotificationContactInfo",
  components: { TheMask },
  data: () => ({
    userDetails: "",
    valid: true,
    mask: "(###)-###-####",
    reportName: "",
    contactInfoList: [],
    contactCount: 1,
    rules: {
      required: (value) => !!value || "Required.",
      min: (v) => v.length >= 10 || "Min 14 characters",
      max: (v) => v.length <= 16 || "Max reached",
    },
  }),
  computed: {
    ...mapGetters([
      "getActiveReportMenu",
      "getSelectedArea",
      "getSelectedTeam",
      "getSelectedBranch",
    ]),
  },
  async mounted() {
    this.addNewContactInfo();
    // await this.getContactDetails();
  },
  watch: {
    "getSelectedArea.Area"() {
      this.getContactDetails();
    },
    "getSelectedTeam.Team"() {
      this.getContactDetails();
    },
    "getSelectedBranch.Office"() {
      this.getContactDetails();
    },
  },

  methods: {
    async addNewContactInfo() {
      let result = this.$refs.contactInfo.validate();
      if (!result) {
        return false;
      }

      let id = this.contactCount;
      let ContactInfo = {
        id: id,
        name: "",
        number: "",
        area: this.getSelectedArea.Area,
        team: this.getSelectedTeam.Team,
        office: this.getSelectedBranch.Office,
        reportName: this.getActiveReportMenu.Name,
      };
      this.contactCount = this.contactCount + 1;
      await this.contactInfoList.push(ContactInfo);
    },
    async getContactDetails() {
      var contactList = await notificationService.getContactsToNotify(
        this.getSelectedArea.Area,
        this.getSelectedTeam.Team,
        this.getSelectedBranch.Office,
        this.getActiveReportMenu.Name
      );
      debugger;

      if (contactList != null && contactList.length > 0) {
        this.contactInfoList = [];
        contactList.forEach((contact) => {
          let id = this.contactCount;
          let ContactInfo = {
            id: id,
            name: contact.Name,
            number: contact.Number,
            area: this.getSelectedArea.Area,
            team: this.getSelectedTeam.Team,
            office: this.getSelectedBranch.Office,
            reportName: this.getActiveReportMenu.Name,
          };
          this.contactCount = this.contactCount + 1;
          this.contactInfoList.push(ContactInfo);
        });
      } else {
        this.addNewContactInfo();
      }
    },

    deleteContact(item) {
      this.$refs.contactInfo.resetValidation();
      if (this.contactInfoList.length == 1) {
        (this.contactInfoList[0].name = ""),
          (this.contactInfoList[0].number = "");
        return false;
      }
      var index = this.contactInfoList.findIndex((x) => x.id == item.id);
      this.contactInfoList.splice(index, 1);
    },
    async InsertContactInfo() {
      let isValidate = this.$refs.contactInfo.validate();

      if (isValidate) {
        var result = await service.InsertNotificationContactInfo(
          this.contactInfoList
        );

        //console.log(result);
        await this.closePopup();
      }
    },
    async cancel() {
      this.contactCount = 1;
      this.contactInfoList = [
        {
          id: this.contactCount,
          name: "",
          number: "",
          area: this.getSelectedArea.Area,
          team: this.getSelectedTeam.Team,
          office: this.getSelectedBranch.Office,
          reportName: this.getActiveReportMenu.Name,
        },
      ];
      this.$refs.contactInfo.resetValidation();
      this.contactCount = this.contactCount + 1;
      this.closePopup();
    },

    closePopup() {
      this.$router.app.$emit("CloseContentInfoPopup");
    },
  },
};
